import * as React from 'react'
import { Alert, Button, Modal } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import Footer from 'components/Footer'
import Header from 'components/Header'
import { useIdentification } from 'hooks/useIdentification'
import { useIdentificationStatus } from 'hooks/useIdentificationStatus'
import loginData from 'utilities/loginData'

const SceneComponent: React.FC = () => {
  const navigate = useNavigate()
  const { startIdentification, error, clearError } = useIdentification()
  const { acceptedStatus, isLoading, checkLoginStatus } = useIdentificationStatus()
  const [enterSucceeded, setEnterSucceeded] = React.useState(false)

  React.useEffect(() => {
    // キャンペーン仮登録のみ完了で住所・口座情報未入力のユーザーはマイページに戻す
    if (loginData.isCampaignAwaitingFullRegistration()) {
      navigate('/myPage', { replace: true })
      return
    }
    checkLoginStatus()
  }, [checkLoginStatus, navigate])

  // エラーモーダルの表示制御
  React.useEffect(() => {
    if (error) {
      // モーダル表示（元の動作を維持）
      // ここではsetModalを使わず、エラー情報を直接使用
    }
  }, [error])

  /**
   * 「本人確認書類を撮影する」ボタン
   */
  const handleStartAuthButton = async () => {
    const success = await startIdentification()
    
    if (success) {
      setEnterSucceeded(true)
    }
  }

  /**
   * 「ポジションを契約する」ボタン
   */
  const handleNextButton = () => {
    navigate('/positionContract')
  }
  return (
    <>
      <Header title="証明書登録" />
      <main>
        <section className="mx-4 my-5">
          <h3 className="fw-bold">個人契約</h3>
          <div className="note">
            <div>※法人契約の方も個人の証明書登録が必要です</div>
            <div>※証明書の登録を行ってください。証明書の撮影が必要になります。</div>
            <div>※法人契約が非承認になった場合は個人の契約になります。</div>
            <div>※運転免許証の記載内容に変更のある場合は証明書登録ができません。</div>
          </div>
          <div className="note mt-3">
            <div>登録可能な証明書は以下となります。</div>
            <div>・パスポート</div>
            <div>・運転免許証</div>
            <div>・マイナンバーカード</div>
            <div>・在留カード</div>
          </div>
          <div className="mt-4">
            {isLoading ? (
              <div className="text-center py-4">
                <div className="spinner-border" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            ) : (
              <>
                {(acceptedStatus || enterSucceeded) && (
                  <Alert variant="success" className="mb-3">
                    本人確認済み
                  </Alert>
                )}
                <div>
                  <Button variant="primary" className="w-100 py-4" onClick={handleStartAuthButton} disabled={!(acceptedStatus == null && !enterSucceeded)}>
                    本人確認書類を撮影する
                  </Button>
                </div>
              </>
            )}
          </div>
        </section>
        <section className="mx-4 my-5">
          <div className="pt-2">
            <Button variant="primary" className="w-100 py-4" onClick={handleNextButton} disabled={!((acceptedStatus == null && enterSucceeded) || acceptedStatus === true)}>
              ポジションを契約する
            </Button>
          </div>
          
        </section>
      </main>
      <Footer className="mt-5" />

      <Modal show={!!error} onHide={clearError}>
        <Modal.Body>{error?.message}</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={clearError}>
            閉じる
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default SceneComponent
